import { Collection } from '../../shared/constants';
import { getDocById, updateDoc } from './collectionBaseWorker';

export const updatePrivateParametersRevenda = async ({ id, data }) => {
    await updateDoc({ collection: Collection.PRIVATE_PARAMETERS_REVENDA, id: id, data: data })
}

export const getPrivateParametersRevendaById = async ({ id }) => {
    return await getDocById({ collection: Collection.PRIVATE_PARAMETERS_REVENDA, id: id })
}